import React from 'react';
import { Box, Typography } from '@material-ui/core';
import AccordionContent from './accordion-content/accordionContent';
import { useStyles } from './sectionAccordion.jss';

const SectionAccordion = ({ content, title }) => {
  const classes = useStyles();
  return (
    <Box>
      <Box maxWidth={1060} margin="0 auto">
        <Typography variant="h2" classes={{ root: classes.title }}>
          {title}
        </Typography>
        {content?.map((item, i) => (
          <AccordionContent data={item} key={i} />
        ))}
      </Box>
    </Box>
  );
};

export default SectionAccordion;
